import { NavListContext, useThrottledHandler } from 'App';
import { useSize } from 'ahooks';
import { Modal, Toast } from 'antd-mobile';
import { useContext, useEffect, useReducer, useRef, useState } from 'react';
import {
    AiOutlineAppstore,
    AiOutlineBorder,
    AiOutlineCheckCircle,
    AiOutlineCrown,
    AiOutlineKey,
    AiOutlineSearch,
} from 'react-icons/ai';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { AppConfigDT, toggleAlbumMode } from 'stores/appConfigSlice';
import styles from './index.module.scss';

const Top1Nav = (data: { onClick: (key: string) => void }) => {
  const navigate = useNavigate();
  const navList = useContext(NavListContext).navList;
  const [activeKey, setActiveKey] = useState(navList.top1TermNow.termUuid);
  const ref = useRef(null);
  const size = useSize(ref);

  useEffect(() => {
    // console.log("top1TermNow", navList.top1TermNow.termUuid);
    setActiveKey(navList.top1TermNow.termUuid);
  }, [navList.top1TermNow.termUuid]);

  const container = document.querySelector('.containerWrapper');
  const scrollbarThumb = document.querySelector('.customScrollbarThumb');
  container?.addEventListener('scroll', () => {
    const scrollPercentage = container.scrollLeft / (container.scrollWidth - container.clientWidth);
    const thumbPosition = scrollPercentage * (container.clientWidth - scrollbarThumb.clientWidth);
    if (scrollbarThumb instanceof HTMLElement) {
      scrollbarThumb.style.transform = `translateX(${thumbPosition}px)`;
    }
  });

  const albumMode: AppConfigDT = useSelector((state: any) => state.appConfigHandle?.albumMode);
  const dispatch = useDispatch();

  useEffect(() => {
    console.log('albumMode', albumMode);
  }, [albumMode]);

  return (
    <>
      <div className=" flex items-center gap-3 p-0.5 bg-orange-400 text-white ">
        <div
          ref={ref}
          className={['relative grow flex -mb-2 mx-0.5', styles.container].join(' ')}
        >
          {navList.top1TermList.map((item, index) => (
            <div
              key={activeKey + '_' + index}
              className={[
                ' text-base py-2 px-2 rounded-t-xl transition transition-200 text-nowrap',
                item.termUuid === activeKey ? ' bg-white text-orange-400 font-bold' : ' ',
              ].join(' ')}
              onClick={() => {
                // TODO 禁止点击, 有数据后再开放
                // Toast.clear();
                // Toast.show("前方区域, 请稍后探索吧 ❤");
                // return;
                data.onClick(item.termUuid);
                setActiveKey(item.termUuid);
              }}
            >
              {item.termName}
            </div>
          ))}
          {false && (
            <>
              <div
                className=" bg-slate-700 fixed top-0 left-0 w-3"
                style={{
                  height: size?.height + 10,
                  background: 'linear-gradient(to right, rgba(0, 0, 0, 0.3), transparent)',
                }}
              />
              <div
                className=" bg-slate-700 fixed top-0 -left-2 w-3 "
                style={{
                  left: size?.width,
                  height: size?.height + 10,
                  background: 'linear-gradient(to left, rgba(0, 0, 0, 0.3), transparent)',
                }}
              />
            </>
          )}
        </div>
        <div className=" flex gap-3 mt-1 mr-3 mb-1 whitespace-nowrap text-xs">
          <div
            className={[
              ' flex justify-center items-center gap-0.5 text-sm shadow-md rounded-md px-1.5 py-1 bg-gradient-to-r',
              !albumMode ? 'from-orange-500 to-pink-500' : 'from-red-500 to-purple-600',
            ].join(' ')}
            onClick={() => {
              // setTimeout(() => {
              //   navigate("/sesame");
              // }, 3000);
              dispatch(toggleAlbumMode());
            }}
          >
            <div>{!albumMode ? <AiOutlineAppstore size={16} /> : <AiOutlineBorder size={16} />}</div>
            <div>{!albumMode ? '画廊' : '单图'}</div>
          </div>
          {/* <div
            className=" flex justify-center items-center gap-0.5 text-sm shadow-md rounded-md px-1.5 py-1 bg-gradient-to-r from-orange-500 to-pink-500"
            onClick={() => {
              Toast.show("即将进入口令模式");
              setTimeout(() => {
                navigate("/sesame");
              }, 1500);
            }}
          >
            <AiOutlineKey size={16} />
            <div>口令</div>
          </div> */}
          {/* <div
            className=" flex justify-center items-center gap-0.5 text-sm shadow-md rounded-md px-1.5 py-1 bg-orange-600"
            onClick={() => {
              navigate("/search", {
                state: {
                  searchAllCategory: true,
                  searchKeyword: null,
                  searchCategoryId: null,
                  searchCategory: "所有资源",
                },
              });
              // TODO: 弹出搜索框比较好, 或者优化搜索界面
              // Modal.show({
              //   title: "搜索结果",
              //   showCloseButton: true,
              //   content: (
              //     <>
              //       <div></div>
              //     </>
              //   )
              // });
            }}
          >
            <AiOutlineSearch size={16} />
            <div>搜索</div>
          </div> */}
          {/* <div className=" flex flex-col items-center justify-center gap-0.5">
            <AiOutlineCrown size={16} />
            <div>VIP</div>
          </div> */}
          {/* <div className=" flex flex-col items-center justify-center gap-0.5">
            <AiOutlineCheckCircle size={16} />
            <div>签到</div>
          </div> */}
        </div>
      </div>
    </>
  );
};

export default Top1Nav;
